import qs from 'qs';
import { fetchApi, getOrganisationId } from 'shared/functions';

export const recentUsersService = () => {
  const organisationId = getOrganisationId();

  const params = {
    page: 1,
    limit: 5,
  };

  return fetchApi(
    `/sso/social/organisations/${organisationId}/recent-users?${qs.stringify(params)}`,
  ).then(response => response.json());
};
